export const defaultFormFieldTypes = [
    {
        value: 'text',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-group',
            input: 'form-control',
            label: 'form-label floating-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'email',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-group',
            input: 'form-control',
            label: 'form-label floating-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'number',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-group',
            input: 'form-control',
            label: 'form-label floating-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'textarea',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-group',
            input: 'form-control',
            label: 'form-label floating-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'select',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-group',
            input: 'form-control',
            label: 'form-label floating-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'checkbox',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-check',
            input: 'form-check-input',
            label: 'form-check-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'date',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-datepicker form-group',
            input: 'form-control',
            label: 'form-label floating-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'radio-group',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'position-relative',
            fieldset: 'form-group',
            legend: 'form-label',
            group: 'radio-group',
            item: 'form-check',
            input: 'form-check-input',
            itemLabel: 'form-check-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__group-errors js-form-validation__errors invalid-feedback',
        }
    },
    {
        value: 'checkbox-group',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'position-relative',
            fieldset: 'form-group',
            legend: 'form-label',
            group: 'checkbox-group',
            item: 'form-check',
            input: 'form-check-input',
            itemLabel: 'form-check-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors js-form-validation__group-errors invalid-feedback',
        }
    },
    {
        value: 'file',
        classes: {
            wrapper: 'js-form-validation__group',
            container: 'form-group',
            input: 'form-control',
            label: 'form-label',
            help: 'form-text text-muted',
            errors: 'form-errors js-form-validation__errors invalid-feedback',
        }
    },
]

export const defaultAdditionalFieldTypes = [
    {
        value: 'title',
        elementType: 'h3',
        classes: {
            title: 'form-title h3',
        }
    },
    {
        value: 'subtitle',
        elementType: 'h5',
        classes: {
            title: 'form-subtitle h5',
        }
    },
    {
        value: 'spacer',
        classes: {
            spacer: '',
        }
    },
    {
        value: 'textfield',
        classes: {
            wrapper: 'text-wrapper wysiwyg',
        }
    },
    {
        value: 'small-textfield',
        classes: {
            wrapper: 'small-text-wrapper wysiwyg',
        }
    },
    {
        value: 'divider',
        classes: {
            divider: '',
        }
    }
]
